// Data Privacy
export const PrivacyConsent = "PrivacyConsent";
export const DataSecureConsent = "DataSecureConsent";

// Employee Details
export const JobTitle = "JobTitle";
export const Postcode = "Postcode";
export const MobilePhone = "MobilePhone";
export const HomePhone = "HomePhone";
export const EmployeeId = "EmployeeId";
export const OrgLevel1Id = "OrgLevel1Id";
export const OrgLevel1Name = "OrgLevel1Name";
export const OrgLevel2Id = "OrgLevel2Id";
export const OrgLevel2Name = "OrgLevel2Name";
export const OrgLevel3Id = "OrgLevel3Id";
export const OrgLevel3Name = "OrgLevel3Name";
export const OrgLevel4Id = "OrgLevel4Id";
export const OrgLevel4Name = "OrgLevel4Name";

// Case Details
export const PurchaseOrderNumber = "PurchaseOrderNumber";

// Reason for Referral
export const AbsenceReason = "AbsenceReason";
export const BodyPartAffected = "BodyPartAffected";
export const CurrentWorkStatus = "CurrentWorkStatus";
export const FirstDayOfAbsence = "FirstDayOfAbsence";
export const AdditionalInformation = "AdditionalInformation";

// Attachments
export const Attachments = "Attachments";
